export default {"src":"/_next/static/media/zadro-logo.26d1972f.svg","height":113,"width":222};